define('$location', function() {
  return window.location;
});
